import { type ToolCallSummary } from '@/features/types/tools';

export enum MessageType {
  USER = 'user',
  AI_AGENT = 'ai_agent',
}

interface HumanMessage {
  id: string;
  content: string;
  type: MessageType.USER;
  timestamp: string;
  attachments: Array<PrinceAttachment>;
}

interface UserRating {
  score: number;
  comment?: string;
}

export interface AiMessage {
  id: string;
  agentRunId: string;
  content: Array<string | ToolCallSummary>;
  type: MessageType.AI_AGENT;
  timestamp: string;
  attachments: Array<PrinceAttachment>;
  isStreaming: boolean;
  isAborted?: boolean;
  autoContinuation?: AutoContinuationState;
  userRating?: UserRating;
}

export type Message = HumanMessage | AiMessage;

export interface PrinceAttachment {
  id: string;
  isCanvas: boolean;
  name: string;
  lastModified?: string;
}

export interface AutoContinuationState {
  limitReached: boolean;
  continuationAttempts?: number;
  maxAutoContinuations?: number;
}
